
import { Component, Vue } from 'vue-property-decorator'
import {gtm} from "@/util/GTMService";
import { httpService } from '@/util/HttpAdapter';
import {v4 as uuidv4} from "uuid";

@Component({ components: {} })
export default class KionOzon extends Vue {
	async mounted() {
		gtm.clearSessionSaveOldRequestId(
			window.sessionStorage.getItem("request_id"),
			window.sessionStorage.getItem("subscriptionExist"),
			window.sessionStorage.getItem("buttonSubscription"),
			window.sessionStorage.getItem("analyticsQuery")
		)

		try {
			const { data } = await httpService.validate();
			const isSessionCookieValid = data.isSessionCookieValid;

			if (isSessionCookieValid) {
				const token = localStorage.getItem("accessToken");

				if (!token) {
					this.webSsoAuth();
				} else {
					httpService.accessToken = token
					this.checkSubscription();
				}
			} else {
				this.webSsoAuth();
			}
		} catch (error) {
			this.webSsoAuth();
		}
	}

	pushSubscriptions() {
		this.$router.push({path: '/subscriptions', query: gtm.getAnalyticsQuery()});
	}

  async checkSubscription() {
	try {
		const statusPromotion = (await httpService.filterAppliedSubscriptions(httpService.selectedSubscription)).data;
		if (statusPromotion.length !== 0) {
			window.location.assign("https://kion.ru");
		} else {
			this.pushSubscriptions();
		}
	} catch (error) {
		this.pushSubscriptions();
	}
  }

   webSsoAuth() {
    window.sessionStorage.setItem("request_id", uuidv4())
    gtm.pushEvent({
     event: 'authorization_start',
     event_name: 'authorization_start',
     referer: httpService.previousPage,
     auth_method: "sms",
     auth_type: 'websso',
     request_id: window.sessionStorage.getItem("request_id")
    })
    const hostUrl = window.location.host
    window.location.assign(
     encodeURI(
      `https://prod.tvh.mts.ru/tvh-public-api-gateway/public/rest/general/websso/redirect?state=${ window.sessionStorage.getItem("request_id") + '_' }PGNVY&clientType=WEB&domain=${hostUrl}`
     )
    );
   }
}
